import React, { useEffect } from 'react'
import { COPY_STRINGS } from '../../../../constants/translatedCopy'
import { LOCAL_STORAGE_FLAGS } from '../../constants'
import { isChromeDesktop, isEdgeDesktop } from '../../functions/browserChecks'
import StudentInstruction from '../../Components/StudentInstruction'
import { GetBrandedAppName, GetBrandedTutorName } from '../../../../services/BrandingService'
import { getCopyByGradeband } from '../../../../services/ThemingService'

export const IMAGES_BLOCKED_ERROR_CODE = '1236'

/**
 * TT-1378 / CR-10713: shown when the image-render probe finds that the browser
 * will not display images for this site. Deliberately text-only: every image
 * (including the static Amira fallback and the instruction illustrations) is
 * invisible in this state, so words are the only thing that can reach the
 * student and the teacher.
 */
export default React.memo(function InstructToFixImagesBlocked(props) {

    const { speechProps, toggleReaderContainer, failureReturnUrl } = props

    useEffect(() => {
        toggleReaderContainer()
        speechProps.abortDance()
        const speechPattern = async () => {
            const studentChecks = getCopyByGradeband(COPY_STRINGS, 'student_checks')
            await speechProps.speakWithPromise({ textToSpeak: studentChecks.student_images_blocked })
            await speechProps.speakWithPromise({ textToSpeak: studentChecks.student_hardware_denied_two })
        }
        speechProps.abortSpeech(speechPattern)

        return () => {
            toggleReaderContainer()
        }
    }, [])

    const browserName = isChromeDesktop() ? 'Chrome' : isEdgeDesktop() ? 'Edge' : 'this browser'
    const siteHost = window.location.hostname || 'this site'

    const handleReload = () => {
        // The browser applies a changed Images setting on the next page load. Skip the
        // FTUE intro on the way back in, same as the manual microphone-permission fix.
        localStorage.setItem(LOCAL_STORAGE_FLAGS.READY_MODULE_SKIP_FTUE_INTRO, true)
        if (failureReturnUrl) {
            window.location.href = failureReturnUrl
        } else {
            window.location.reload()
        }
    }

    return <div>
        <StudentInstruction>
            <h2>Raise your hand</h2>
            <p>Images are turned off for this site in {browserName}, so {GetBrandedTutorName()} and the reading screen cannot be shown.</p>
            <p>Teacher: in {browserName}, click the icon at the right end of the address bar (or open Site settings for <strong>{siteHost}</strong>) and set <strong>Images</strong> to <strong>Allow</strong>. If that setting is locked, your IT team controls it. Then tap Reload.</p>
            <button onClick={handleReload}>Reload</button>
            <p>Need help? Contact <a href="mailto:support@amiralearning.com">support@amiralearning.com</a> and mention that images are blocked for {GetBrandedAppName()}. Error code: {IMAGES_BLOCKED_ERROR_CODE}</p>
        </StudentInstruction>
    </div>
})
